// Suppress SDK "Failed to delete pin" errors from the dev overlay.
// Must be registered before CRA's error overlay sets up its own listeners.
(function () {
  const isDeletePinError = (msg) => {
    const s = String(msg || "").toLowerCase();
    return s.includes("failed to delete pin") || s.includes("delete pin");
  };
  window.addEventListener("error", (e) => {
    if (isDeletePinError(e.message || e.error?.message)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true); // capture phase — runs before bubble-phase CRA listeners
  window.addEventListener("unhandledrejection", (e) => {
    const msg = e.reason?.message || (typeof e.reason === "string" ? e.reason : "");
    if (isDeletePinError(msg)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
})();

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/global.scss";
import SignupContext from "context/SignupContext";
import SigninContext from "context/SigninContext";
import { ToastProvider } from "components/Toaster/index";
import { ThemeProvider } from "context/ThemeContext";
import { addCollection } from "@iconify/react";
import iconsMdi from "./assets/icons-mdi.json";

// Localize Icons
addCollection(iconsMdi);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ToastProvider>
      <ThemeProvider>
        <SignupContext>
          <SigninContext>
            <App />
          </SigninContext>
        </SignupContext>
      </ThemeProvider>
    </ToastProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
